// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.myBack .el-badge__content {\n\tbackground-color: transparent;\n\tborder-radius: 10px;\n\tcolor: #da1414;\n\tdisplay: inline-block;\n\tfont-size: 12px;\n\theight: 18px;\n\tline-height: 18px;\n\tpadding: 0 6px;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tborder: 0 solid #fff;\n}\n.myBack sup {\n\ttop: -1.5em;\n\tposition: absolute;\n\tleft: -14px;\n}\n", ""]);
// Exports
module.exports = exports;
